module.exports = {"610681001":"瓦窑堡街道","610681002":"秀延街道","610681003":"栾家坪街道","610681101":"杨家园则镇","610681102":"玉家湾镇","610681103":"安定镇","610681104":"马家砭镇","610681105":"南沟岔镇","610681106":"涧峪岔镇","610681107":"李家岔镇","610681108":"余家坪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610681.json
// module id = 2984
// module chunks = 0